// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-Header----styles-module---header---L-KIn","link":"src-components-Header----styles-module---link---Zl1H9","howToFindUs":"src-components-Header----styles-module---howToFindUs---2nJ6X","call":"src-components-Header----styles-module---call---26oQ-","mapIcon":"src-components-Header----styles-module---mapIcon---186fX","dropdownIcon":"src-components-Header----styles-module---dropdownIcon---2C4n-","languageDropdown":"src-components-Header----styles-module---languageDropdown---19lF1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/styles.module.css
// module id = 502
// module chunks = 114276838955818